const fruits = [
  {
    name: 'pineapple',
    color: '#ca0',
  },
  {
    name: 'banana',
    color: '#bb0',
  },
  {
    name: 'acai',
    color: '#60a',
  },
  {
    name: 'coconut',
    color: '#750',
  },
  {
    name: 'dragonfruit',
    color: '#b0b',
  },
  {
    name: 'tomato',
    color: '#c00',
  },
  {
    name: 'blueberry',
    color: '#50b',
  },
  {
    name: 'kiwi',
    color: '#4b0',
  },
  {
    name: 'gooseberry',
    color: '#cc0',
  },
  {
    name: 'pomegranate',
    color: '#a04',
  },
  {
    name: 'papaya',
    color: '#f97',
  },
  {
    name: 'durian',
    color: '#bc0',
  },
  {
    name: 'mango',
    color: '#fd0',
  },
  {
    name: 'mandarin',
    color: '#fb2',
  },
  {
    name: 'lime',
    color: '#0b0',
  },
  {
    name: 'lemon',
    color: '#ee0',
  },
  {
    name: 'orange',
    color: '#fb0',
  },
  {
    name: 'grapefruit',
    color: '#f90',
  },
  {
    name: 'pomelo',
    color: '#9e0',
  },
  {
    name: 'watermelon',
    color: '#090',
  },
  {
    name: 'honeydew',
    color: '#4e0',
  },
  {
    name: 'cantaloupe',
    color: '#fc0',
  },
  {
    name: 'strawberry',
    color: '#e00',
  },
  {
    name: 'raspberry',
    color: '#b03',
  },
  {
    name: 'apple',
    color: '#d00',
  },
  {
    name: 'pear',
    color: '#8b0',
  },
  {
    name: 'cherry',
    color: '#b02',
  },
  {
    name: 'peach',
    color: '#da0',
  },
  {
    name: 'plum',
    color: '#806',
  },
  {
    name: 'apricot',
    color: '#fb0',
  },
];

const groups = [
  {
    key: 'angiosperms',
    name: ['flowering', 'plants'],
    bioNames: [
      'flowering plants',
      'angiosperms',
    ],
    left: 'monocots',
    right: 'dicots',
    mya: 200,
    alwaysSelected: true,
    width: 85,
  },
  {
    name: 'monocots',
    bioNames: [
      'monocots',
      'commelinids',
    ],
    left: 'pineapple',
    right: 'palmP',
    mya: 110,
    alwaysSelected: true,
  },
  {
    key: 'palmP',
    left: 'banana',
    right: 'palms',
    mya: 85,
  },
  {
    name: 'palms',
    bioNames: [
      'palms',
      'Arecaceae',
    ],
    left: 'acai',
    right: 'coconut',
    mya: 35,
    alwaysSelected: true,
    width: 60,
  },
  {
    name: 'dicots',
    bioNames: [
      'dicots',
      'pentapetaleae',
    ],
    left: 'asteridP',
    right: 'rosidP',
    mya: 130,
    alwaysSelected: true,
    width: 60,
  },
  {
    key: 'asteridP',
    left: 'asterids',
    right: 'dragonfruit',
    mya: 105,
  },
  {
    name: 'asterids',
    left: 'ericales',
    right: 'tomato',
    mya: 100,
    width: 70,
  },
  {
    name: 'ericales',
    left: 'blueberry',
    right: 'kiwi',
    mya: 46,
    width: 80,
  },
  {
    key: 'rosidP',
    left: 'gooseberry',
    right: 'rosids',
    mya: 120,
  },
  {
    name: 'rosids',
    left: 'malvidP',
    right: 'fabids',
    mya: 115,
    width: 70,
  },
  {
    key: 'malvidP',
    left: 'pomegranate',
    right: 'malvids',
    myaLb: 110,
    myaUb: 115,
  },
  {
    name: 'malvids',
    left: 'durianP',
    right: 'sapindales',
    myaLb: 105,
    myaUb: 110,
  },
  {
    key: 'durianP',
    left: 'papaya',
    right: 'durian',
    mya: 100,
  },
  {
    name: 'sapindales',
    left: 'mango',
    right: 'citrus',
    mya: 15,
  },
  {
    name: 'citrus',
    left: 'mandarin',
    right: 'limeP',
    mya: 6,
    alwaysSelected: true,
    width: 60,
  },
  {
    key: 'limeP',
    left: 'lime',
    right: 'lemonP',
    mya: 4,
  },
  {
    key: 'lemonP',
    left: 'lemon',
    right: 'orangeP',
    mya: 0.75,
  },
  {
    key: 'orangeP',
    left: 'orange',
    right: 'grapefruitP',
    mya: 0.5,
  },
  {
    key: 'grapefruitP',
    left: 'grapefruit',
    right: 'pomelo',
    myaLb: 0.01,
    myaUb: 0.1,
  },
  {
    name: 'fabids',
    left: 'roses',
    right: 'melons',
    myaLb: 110,
    myaUb: 115,
  },
  {
    name: 'roses',
    bioNames: [
      'roses',
      'rosaceae',
    ],
    left: 'rosoideae',
    right: 'appleP',
    mya: 100,
    alwaysSelected: true,
    width: 55,
  },
  {
    name: 'rosoideae',
    left: 'strawberry',
    right: 'raspberry',
    mya: 65,
  },
  {
    key: 'appleP',
    left: 'maleae',
    right: 'prunes',
    bioNames: [
      'members of the apple subfamily',
      'amygdaloideae',
    ],
    mya: 90,
  },
  {
    key: 'maleae',
    left: 'apple',
    right: 'pear',
    mya: 25,
  },
  {
    name: 'prunes',
    bioNames: ['prunes', 'prunus', 'amygdaleae'],
    left: 'cherry',
    right: 'peachP',
    myaLb: 18,
    myaUb: 25,
    width: 72,
    alwaysSelected: true,
  },
  {
    key: 'peachP',
    left: 'peach',
    right: 'plumP',
    mya: 15,
  },
  {
    key: 'plumP',
    left: 'apricot',
    right: 'plum',
    mya: 10,
  },
  {
    name: 'melons',
    bioNames: [
      'melons',
      'benincaseae',
    ],
    left: 'watermelon',
    right: 'muskmelon',
    myaLb: 1,
    myaUb: 10,
    alwaysSelected: true,
    width: 65,
  },
  {
    name: 'muskmelon',
    left: 'honeydew',
    right: 'cantaloupe',
    myaLb: 0.01,
    myaUb: 1,
  },
];

fruits.forEach((fruit) => {
  fruit.isFruit = true;
});

const nodes = fruits.concat(groups);
const byKey = {};
nodes.forEach((node) => {
  const key = node.key || node.name;
  byKey[key] = node;
});
// replace strings with actual nodes
groups.forEach((group) => {
  const { left, right } = group;
  group.left = byKey[left];
  group.right = byKey[right];
  group.left.parent = group;
  group.right.parent = group;
});

export default {
  fruits,
  groups,
  nodes,
  rootNode: groups[0],
};



// WEBPACK FOOTER //
// src/components/Fruits/fruitData.js